module.exports = __webpack_public_path__ + "static/media/arzel_logo.406ceae5.svg";